import Index from './index.vue'
import Dashboard from './views/Dashboard.vue'
import Profile from './views/Profile.vue'
import UpSale from './views/UpSale.vue'
import List from './components/List.vue'
import Search from './views/Search.vue'
import Create from './views/Create.vue'
import SignUpsList from './components/SignUpList.vue'

export default [
  {
    path: '/location',
    name: 'location',
    component: Index,
    title: 'Location',
    redirect: { name: 'location-dashboard' },
    children: [
      {
        path: 'dashboard',
        name: 'location-dashboard',
        component: Dashboard,
      },
      {
        path: 'signups',
        name: 'signUps-list',
        component: SignUpsList,
      },
      {
        path: 'search',
        name: 'search-location',
        component: Search,
      },
      {
        path: ':id/new',
        name: 'create-location',
        component: Create,
        props: true,
      },
      {
        path: 'welcome',
        name: 'upsale-screen',
        component: UpSale,
        props: true,
      },
      {
        path: 'profile/:id',
        name: 'location-profile',
        component: Profile,
        props: true,
      },
      {
        path: 'list',
        name: 'location-list',
        component: List,
      },
    ],
  },
]
